import * as React from 'react';

import throttle from '../../utils/throttle';
import styles from './index.scss';

const logo = require('./assets/logo.png');
const hamburger = require('./assets/hamburger.png');
const close = require('./assets/close.png');
const user = require('./assets/user.png');

interface IProps {
  history: any;
  handleShowNav: (flag?: boolean) => void;
  handleShowLogin: () => void;
  show: boolean;
}
const { useRef, useEffect } = React;
const Header: React.FunctionComponent<IProps> = ({
  show,
  history,
  handleShowLogin,
  handleShowNav
}) => {
  const headerEl: React.RefObject<HTMLDivElement> = useRef(null);
  useEffect(() => {
    banMove();
  });
  const banMove = () => {
    if (headerEl.current) {
      headerEl.current!.addEventListener('touchmove', function(
        evt: MouseEvent
      ) {
        evt.preventDefault();
      });
    }
  };
  const toggleNav = () => {
    handleShowNav();
  };
  const toggleLogin = () => {
    handleShowLogin();
  };
  return (
    <div className={styles.container} ref={headerEl}>
      <img
        className={styles.logo}
        src={logo}
        alt=''
        onClick={() => {
          handleShowNav(false);
          history.push('/');
        }}
      />
      <div className={styles.action}>
        <img src={user} alt='' onClick={throttle(toggleLogin, null, 200)} />
        {show ? (
          <img src={close} alt='' onClick={throttle(toggleNav, null, 400)} />
        ) : (
          <img
            src={hamburger}
            alt=''
            onClick={throttle(toggleNav, null, 400)}
          />
        )}
      </div>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.tsx